export default __webpack_public_path__ + "static/media/brand_bandes.ea40730e.svg";